module.exports = __webpack_public_path__ + "img/red_bg.d9d66593.png";